<template>
  <v-menu bottom left offset-y>
    <template v-slot:activator="{ on }">
      <v-btn dark icon v-on="on">
        <v-icon>mdi-settings</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item :to="dataMapRoute">
        <v-list-item-title>{{ $t('message.map_view') }}</v-list-item-title>
      </v-list-item>
      <v-list-item :to="dataManagementRoute">
        <v-list-item-title>{{ $t('message.management_view') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'ToolbarView',

  props: {
    mapRoute: {
      type: Object,
      required: false,
      default: null
    },
    managementRoute: {
      type: Object,
      required: false,
      default: null
    }
  },

  data() {
    return {
      dataMapRoute: null,
      dataManagementRoute: null
    }
  },

  created() {
    this.dataMapRoute = this.mapRoute ? this.mapRoute : this.$route
    this.dataManagementRoute = this.managementRoute ? this.managementRoute : this.$route
  }
}
</script>
